import { EMPTY_MESSAGE } from "../profileUtils";
import styles from "../Profile.module.css";

const EmptyState = ({ message = EMPTY_MESSAGE }) => (
  <div className={styles.empty}>{message}</div>
);

export default EmptyState;
